import type { AxiosProgressEvent } from "axios";
import type {
  LmCategoryPropertyVo,
  LoginCheckReq,
  LoginUserVo,
  SsoLoginReq,
  GenerateQrCodeReq,
} from "types/openapi/auth";
import type { LmCategorySearchVo, LmCategoryVo } from "types/openapi/lm";
import { get, post } from "@/http/axios";
/**
 * 通过手机验证码登录
 */
export function loginByCode(data: SsoLoginReq) {
  return post({
    url: "/api/auth/sso/doLogin",
    data,
  });
}
/**
 * 发送验证码
 */
export function sendCode({
  phone,
  systemId,
}: {
  phone: string;
  systemId: string;
}) {
  return post({
    url: "/api/auth/sso/v2/sendVerifyCode",
    data: {
      phone,
      systemId,
    },
    hiddenLoading: true,
  });
}
/**
 * 扫码登录
 */
export function loginByQrCode() {}

/**
 * 用 Ticket 换取 Token
 */
export function getTokenByTicket(data: LoginCheckReq) {
  return post<LoginUserVo>({
    url: "/api/auth/sso/checkLogin",
    data,
  });
}

/**
 * 获取菜单信息
 * @returns
 */
export function getMenuList() {
  return get<LoginUserVo>({
    url: "/api/auth/sso/loginUserInfo",
    hiddenLoading: true,
  });
}

export function uploadFile(options: {
  data: FormData;
  type: "image" | "file";
  onUploadProgress: (progressEvent: AxiosProgressEvent) => void;
}) {
  const { data, type = "image", onUploadProgress = () => {} } = options;
  const url = {
    image: "/api/lm/alliance/file/uploadImage",
    file: "/api/lm/alliance/report/upload",
  }[type || "image"];
  return post({
    url,
    data,
    onUploadProgress,
    hiddenLoading: false,
    toastText: type === "file" ? "文件上传并解析中" : "",
  });
}

/**
 * 类目树（display-true-默认需要筛选企业权限范围）
 */
export function getCategoryTree(display: boolean = true) {
  return get<LmCategoryVo[]>({
    url: "/api/lm/alliance/base/tree",
    params: {
      display,
    },
  });
}

/**
 * 根据类目名称搜索类目
 * @param categoryName
 * @returns
 */
export function getCategoryByName(categoryName?: string) {
  return get<LmCategorySearchVo[]>({
    url: "/api/lm/alliance/base/categorySearch",
    params: {
      categoryName,
    },
    hiddenLoading: true,
  });
}
/**
 * 类目属性搜索
 */
export function getCategoryProperty(categoryCode: string) {
  return get<LmCategoryPropertyVo[]>({
    url: "/api/lm/alliance/base/propertySearch",
    params: {
      categoryCode,
    },
    hiddenLoading: true,
  });
}
